import React, { useState } from 'react';
import { oneOfType, array, object, string, bool } from 'prop-types';
import { withApollo } from 'react-apollo';
import { Menu as AntMenu, Icon } from 'antd';
import adfsAuth from '../../../utils/adfsAuth';
import { Text } from '../../common';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa';
import { generateTraceabilityUtil } from '../../../utils/misc';

const colorChange = urlSisa() === urlBase() ? '#4daea9' : '#1fa02e';

const LogoutMenuItem = ({ client, path, currentPathname, collapsed, ...props }) => {

    const [hovered, toggleHover] = useState(false);
    const isActive = currentPathname === path;
    const color = isActive || (hovered && !collapsed) ? colorChange : '#ffffff';

    const onLogout = async () => {
        await generateTraceabilityUtil(client, { actionId: 7 });
        adfsAuth.logout(() => {
            sessionStorage.clear();
            window.location.href = '/';
        });
        /* logOut()
        .then((res) => {
            console.log(res)
            window.location.reload()
        })
        .catch((err) => console.log(err)) */
    };

    return (
        <AntMenu.Item
            {...props}
            key='logout'
            onClick={onLogout}
            onMouseEnter={() => toggleHover(!hovered)}
            onMouseLeave={() => toggleHover(!hovered)}
        >
            <Icon style={{ color }} type='logout' rotate={180} />
            <Text color={color} text='sidebar.navigation.exit' />
        </AntMenu.Item>
    );
};

LogoutMenuItem.propTypes = {
    client: oneOfType([array, object]),
    path: string,
    currentPathname: string,
    collapsed: bool
};

LogoutMenuItem.defaultProps = {
    client: {},
    path: '',
    currentPathname: '',
    collapsed: false
};

export default withApollo(LogoutMenuItem);
